// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"08abbbf1","455":"e4935c67","977":"9adec9ca"}[chunkId] + ".chunk.js";
};